import { render, staticRenderFns } from "./AppBarExtInstitution.vue?vue&type=template&id=71d0a9eb"
import script from "./AppBarExtInstitution.vue?vue&type=script&lang=js"
export * from "./AppBarExtInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports